import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./projectcard.scss";
import { isLocalhost } from "../../../../checkLocalhost.jsx";
import { useState,useEffect } from "react";

import home3 from "../../../assets/home3.png";
// import pin from "../../assets/pin.png";
import features from "../../../assets/features.png";
import bed from "../../../assets/bed.png";
import bath from "../../../assets/bath.png";
import size from "../../../assets/size.png";
import rupeesign from "../../../assets/rupee-sign_10432907.png";
// import save from "../../assets/save.png";
// import chat from "../../assets/chat.png";
import noimage from "../../../assets/no-image-icon-23494.png";

import { AuthContext } from "../../../context/AuthContext.jsx";
import apiRequest from "../../../lib/apiRequest.js";
import { formatDate, formatMonthYear, formatToIndianRupees, generatePostMessage } from "../../../lib/allPurposeFunctions.js";
import { MapPinIcon } from "../../../lib/myIcons.jsx";
import  DOMPurify  from 'dompurify';




function ProjectCard({
  item,
  onNavigateSaveProject,
  onNavigateProjectView,

}) {

  // console.log("ProjectCard Item: ",item)

// let filenames = [];
// let builder={};
// let posession={};
// try {
//   filenames = JSON.parse(item?.media || "[]").map(m => m.filename);
//   builder = JSON.parse(item?.builder || "{}");
//   posession = JSON.parse(item?.possession || "{}");
// } catch (e) {
//   console.error(e);
// }


  const projectimagelocation = isLocalhost
    ? `${import.meta.env.VITE_PROJECTIMAGES_BASEURL}/${item.id}`
    : `${import.meta.env.VITE_PROJECTIMAGES_SH_BASEURL}/${item.id}`;



// console.log("filenames: " ,filenames)
// console.log("builder: " ,builder)
  // item.images=filenames;
  // item.builder=builder;
  // item.posession=posession;


  const navigate = useNavigate();

  const { currentUser } = useContext(AuthContext);

  // const builderimageslocation = isLocalhost
  //   ? import.meta.env.VITE_SERVER_BASEURL + "/"
  //   : import.meta.env.VITE_SH_DSERVER_BASEURL + "/";

  //  const SERVER_DBASEURL=  import.meta.env.VITE_IS_LOCALHOST=='true'
  // const SERVER_DBASEURL = isLocalhost
  //   ? import.meta.env.VITE_DSERVER_BASEURL + import.meta.env.VITE_API
  //   : import.meta.env.VITE_SH_DSERVER_BASEURL + import.meta.env.VITE_API;


    // console.log("")

  const handleUserProfileClick = (userId) => (e) => {
    e.preventDefault();
    e.stopPropagation(); // Prevent the click from propagating to the card
    // console.log("User ID:", userId); // Log the user ID to the console

    navigate(`/displayprofile/${userId}`);
  };


  const handleCardClick = (Project) => (e) => {
    e.preventDefault();
    // alert(Post.id)
    e.stopPropagation(); // Prevent the click from propagating to the card

    // const isSuperAdmin =      currentUser && currentUser.IsSuperAdmin==1;

    const isSuperAdmin=false;


    // ✅ If parent wants control, delegate and STOP
    if (onNavigateSaveProject || onNavigateProjectView) {
      if (isSuperAdmin) {
        onNavigateSaveProject?.(Project);
      } else {
        onNavigateProjectView?.(Project);
      }
      return; // 🚨 DO NOTHING ELSE
    }
    // if (currentUser && Post.userid === currentUser.id) {
    if (isSuperAdmin) {
      navigate("/dashboard/saveproject", {
        state: { mode: 0, project: Project },
      });
    } else {
      navigate(`/projects/${Project.id}`,
        {
          state: {
            project: Project,
          },
        }
      );
    }
  };



  return (
    <div className="projectCard">
      {/* ⬇️ Added checkbox for selection */}


      <div className="imageContainer" onClick={handleCardClick(item)}>
        {/* {console.log("Item Images",item)} */}


        {item.images && item.images.length > 0 ? (
          (() => {

            const firstImage = String(item.images?.[0].filename || "");

            // console.log("First Image",firstImage)
            // if (item.id==='6434'){
            //   console.log("images",item.images)
            //   console.log("First Image",firstImage)

            // }


            const propimage = `${projectimagelocation}/${firstImage}`;
            // console.log("propimage",propimage)
            
            // console.log("First Image",firstImage);
            // console.log("propimage",propimage);

            // console.log("card image: ", firstImage);
            // console.log("Card Item: ", item);

            return (
              <img
                src={propimage}
                alt=""
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = noimage;
                  e.target.style.width = "150px";
                  e.target.style.height = "150px";
                  e.target.style.display = "block";
                }}
              />
            );
          })()
        ) : (
          <img src={home3} alt="No image available" />
        )}
      </div>

      <div className="textContainer">
        <h2 className="title">
          <div onClick={handleCardClick(item)}>{item.projectname}</div>
        </h2>

        <p className="heading">
          {item.heading || item.subheading}
        </p>

        <p className="address">

          <MapPinIcon size={"16px"} color="grey"></MapPinIcon>

          <span>
            {[
              item.colonyname,
              item.city,
            ]
              .filter(Boolean)
              .join(", ")}
          </span>
          

        </p>


        <div className="possession">
          {/* {console.log("Cards item.tags:",item.tags)} */}
          <img src={features} alt="" />
          <span>   {item.completionstatus}, {formatMonthYear( item.completiondate)} </span>
        </div>


        <div className="price">

          <div className="features">
            
            
            <div className="feature">
              <img src={rupeesign} alt="" />
              <span>
                {item.price_range}
              </span>
            </div>


          </div>
        </div>
        {/* <p className="price"></p> */}

        <div className="bottom">
          <div className="icons">
            <div
              className="usertype"
              onClick={handleUserProfileClick(item.userid)}
            >
              
              <div className="clientName">
                {item.builder.buildername}

                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProjectCard;
